import { getType, Instance, isStateTreeNode } from 'mobx-state-tree'
import { Topic } from '../models/Topic'

export const isTopic = (topic: any): topic is Instance<typeof Topic> => {
  return topic && isStateTreeNode(topic) && getType(topic).name === 'Topic'
}
